import * as S from './styles';

export type TagTypes = {
  children: string | React.ReactNode;
  variant?: 'primary' | 'secondary';
};

const Tag = ({ children, variant = 'primary' }: TagTypes) => (
  <S.Wrapper variant={variant}>{children}</S.Wrapper>
);

export default Tag;
